import { useMsal } from '@azure/msal-react';
import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { DisconnectDesk, MiniBurgerDesk, ToInfoDesk } from 'Images';
import { OutroToolTip } from './OutroToolTip';
import { useNavigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsLawyer } from 'Hooks/useIsLawyer';

interface IMenuOutro {
  isLaptopViewOrClosedMenu: boolean;
}

export const MenuOutro = ({ isLaptopViewOrClosedMenu }: IMenuOutro) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MobileMenu);
  const { instance, inProgress } = useMsal();

  const navigate = useNavigate();

  const isLawyer = useIsLawyer();

  const onClickDisconnect = async () => {
    if (inProgress === InteractionStatus.None) {
      sessionStorage.removeItem('B2CToken');
      sessionStorage.removeItem('token');
      await instance.logoutRedirect();
    }
  };

  return (
    <Stack direction='column' sx={{ margin: '20px 0 100px 0' }}>
      {!isLawyer && (
        <>
          <OutroToolTip
            image={MiniBurgerDesk}
            text={dictionary.fullActionList}
            isLaptopViewOrClosedMenu={isLaptopViewOrClosedMenu}
            onClick={() => navigate('/activities-lobby')}
          />

          <OutroToolTip
            image={ToInfoDesk}
            text={dictionary.toInfo}
            isLaptopViewOrClosedMenu={isLaptopViewOrClosedMenu}
            onClick={() =>
              window.open(import.meta.env.VITE_APP_MARKETING_SITE_URL)
            }
          />
        </>
      )}
      <OutroToolTip
        image={DisconnectDesk}
        text={dictionary.disconnect}
        isLaptopViewOrClosedMenu={isLaptopViewOrClosedMenu}
        onClick={() => onClickDisconnect()}
      />
    </Stack>
  );
};
